import React from 'react';
import { Input, FormControl } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(theme => ({
  text: {
    '& .MuiInputBase-input, & .MuiInputLabel-outlined': {
      fontSize: theme.spacing(1.75),
      color: 'black',
      lineHeight: 2,
      padding: theme.spacing(1, 1.5),
    },
    '& .MuiFormHelperText-root.Mui-error': {
      margin: theme.spacing(0),
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: theme.spacing(0),
      borderColor: 'white',
    },
    backgroundColor: 'white',

  },
}));
export default function InputField(props) {
  const {
    name, label, value, error = null, type = '', errorDisable = false, onChange, ...others
  } = props;
  const classes = useStyles();

  return (
    <FormControl className={classes.formControl}>
      <Input
        name={name}
        value={value}
        onChange={onChange}
        type={type}
        size="small"
        fullWidth
        disableUnderline
        placeholder={label}
        className={classes.text}
        {...others}
      />
      {(error && !errorDisable) && <p>{error}</p>}
    </FormControl>
  );
}
